import * as React from "react";
import { Link } from "react-router-dom";
import BackLink from "../../../../components/atoms/BackLink";
import { BlockRow } from "../../../../components/atoms/BlockRow";
import { Flex } from "../../../../components/atoms/Flex";
import Loader from "../../../../components/atoms/Loader";
import { MainSection } from "../../../../components/atoms/MainSection";
import { OutletContextProps } from "../../../../helpers/RouterHelper";
import { SelectDistributeStudentModal } from "../SelectDistributeTagModal";
import { CourseSummary } from "./CourseSummary";
import { StudentList } from "./StudentList";
import styles from "./styles.scss";
import { useSectionsSettingsCourseStudents } from "./useSectionsSettingsCourseStudents";

export const SectionsSettingsCourseStudents = (props: OutletContextProps) => {
  React.useEffect(() => {
    props.setActiveMenu("courses");
  }, []);
  const {
    course,
    courseStudents,
    isDeleting,
    isCourseLoading,
    isCourseStudentsLoading,
    onClickDelete,
    isModalOpen,
    openModal,
    closeModal,
    sectionId,
    onFetchNextPage,
  } = useSectionsSettingsCourseStudents();

  if (isCourseLoading || !course) {
    return <Loader loading={true} />;
  }

  return (
    <BlockRow marginTop="1.6rem">
      <BackLink path={`/sections/${sectionId}/settings/content_courses`}>
        戻る
      </BackLink>
      <MainSection>
        <CourseSummary
          course={course}
          isSubmitting={isDeleting}
          onClickDelete={onClickDelete}
          onClickRegisterTag={openModal}
        />
        <StudentList
          courseStudents={courseStudents}
          isLoading={isCourseStudentsLoading}
          onFetchNextPage={onFetchNextPage}
        />
        <Flex marginTop="2.4rem" justifyContent="flex-end">
          <Link
            to={`/sections/${sectionId}/settings/content_courses`}
            className={`buiButtonBase buiButtonVariantFilled buiButtonSizeLg ${styles.contentCourseLinkButton}`}
          >
            コース一覧
          </Link>
        </Flex>
      </MainSection>
      <SelectDistributeStudentModal
        isOpen={isModalOpen}
        onCloseModal={closeModal}
        sectionId={sectionId}
        contentCourse={course}
      />
    </BlockRow>
  );
};
